import { gql } from '@apollo/client';

export type AlgorithmQueryData = {
  algorithm: {
    data: {
      id: string;
      type: 'algorithms';
      attributes: {
        algorithm_type: string;
        entity_type: string;
        entity_ids: string[];
      };
    };
  };
};

export type AlgorithmQueryVars = {
  id: string;
  input: {
    data: {
      type: 'algorithms';
      attributes: { [key: string]: string | number | null | undefined };
    };
  };
};

export const ALGORITHM_QUERY = gql`
  query AlgorithmQuery($id: String, $input: any) {
    algorithm(id: $id, input: $input)
      @rest(
        type: "AlgorithmPayload"
        method: "POST"
        endpoint: "user"
        path: "/algorithms/{args.id}"
      ) {
      data @type(name: "Algorithm") {
        id
        type
        attributes @type(name: "AlgorithmAttributes") {
          algorithm_type
          entity_type
          entity_ids
        }
      }
    }
  }
`;

export type LookVariantsAttributes = {
  __typename: 'RestLookVariantsAttributes';
  productId: number;
  variantId: string;
};

export type LookVariants = {
  __typename: 'RestLookVariants';
  id: string;
  attributes: LookVariantsAttributes;
};

export type GetLookVariantsQueryVariables = {
  variantId: string;
  countryCode: string;
};

export type GetLookVariantsQuery = {
  getLookVariants: {
    __typename: 'RestLookVariantsPayload';
    data: LookVariants[];
  };
};

export const LOOK_VARIANTS_FRAGMENT = gql`
  fragment LookVariantsFragment on RestLookVariants {
    id
    attributes @type(name: "RestLookVariantsAttributes") {
      productId: product_id
      variantId: variant_id
    }
  }
`;

export const GET_LOOK_VARIANTS_QUERY = gql`
  query LookVariantsQuery($variantId: string!, $countryCode: String!) {
    getLookVariants(variantId: $variantId, countryCode: $countryCode)
      @rest(
        type: "RestLookVariantsPayload"
        endpoint: "variants"
        path: "/v3.1/variants/look_variants?vid={args.variantId}&country_code={args.countryCode}"
      ) {
      data @type(name: "RestLookVariants") {
        ...LookVariantsFragment
      }
    }
  }
  ${LOOK_VARIANTS_FRAGMENT}
`;
